export const createEmptyMessage = () => ({
  error: "",
  success: "",
});

export const getErrorMessage = (error, fallback) => {
  const status = error?.response?.status;
  const data = error?.response?.data;

  if (!error?.response) {
    return "Could not connect to the server. Please check your connection and try again.";
  }

  if (typeof data === "string" && data.trim()) {
    return data;
  }

  if (data?.message) {
    return data.message;
  }

  if (data?.error) {
    return data.error;
  }

  if (data?.title && !data?.errors) {
    return data.title;
  }

  if (data?.errors) {
    const errorMessages = Object.values(data.errors)
      .flat()
      .filter(Boolean);

    if (errorMessages.length > 0) {
      return errorMessages.join(" ");
    }
  }

  if (Array.isArray(data)) {
    return data.join(" ");
  }

  if (status === 400) {
    return "Something was wrong with the details you entered.";
  }

  if (status === 401 || status === 403) {
    return "Your session has expired. Please log in again.";
  }

  if (status === 500) {
    return "Something went wrong on the server. Please try again.";
  }

  return fallback;
};

export const displayValue = (value) => {
  if (value === null || value === undefined || value === "") {
    return "Not set";
  }

  return value;
};

export const getMinutesText = (value) => {
  if (value === null || value === undefined || value === "") {
    return "Not set";
  }

  return `${value} minutes`;
};